import React, { Component } from 'react'
import { Alert, Modal, Radio, Space, Typography, message } from 'antd'
import { applyVibeProjectPermission } from '../../../request'
import {
  getDefaultPermissionScope,
  getPermissionScopeAvailability,
  hasAllPermissions
} from './operationPermissions'

const { Text } = Typography

const getProjectId = project => (project ? (project.id !== undefined && project.id !== null ? project.id : project.projectId) : null)

/**
 * 权限申请弹窗（从 Profile/VibeProjectList.js 的 renderApplyPermissionModal 抽离）。
 * props：visible / project{id,projectName,projectKind,...} / onClose / onSaved
 * 接口：applyVibeProjectPermission
 */
export default class VibeProjectPermissionApplyDialog extends Component {
  state = {
    scope: 'database',
    databasePermissionType: 'readonly',
    applying: false
  }

  componentDidMount () {
    if (this.props.visible && this.props.project) this.resetScope(this.props.project)
  }

  componentDidUpdate (prevProps) {
    const projectChanged = String(getProjectId(prevProps.project) || '') !== String(getProjectId(this.props.project) || '')
    if (this.props.visible && this.props.project && (!prevProps.visible || projectChanged)) {
      this.resetScope(this.props.project)
    }
  }

  resetScope = project => {
    this.setState({
      scope: getDefaultPermissionScope(project),
      databasePermissionType: 'readonly',
      applying: false
    })
  }

  close = () => {
    if (this.state.applying) return
    if (this.props.onClose) this.props.onClose()
  }

  submit = () => {
    const { project, onClose, onSaved } = this.props
    const { scope, databasePermissionType, applying } = this.state
    const projectId = getProjectId(project)
    if (!projectId || applying || hasAllPermissions(project)) return
    const payload = { projectId, permissionScope: scope }
    if (scope === 'database' || scope === 'all') {
      payload.databasePermissionType = databasePermissionType
    }
    this.setState({ applying: true })
    applyVibeProjectPermission(payload)
      .then(res => {
        message.success('申请已提交，7天内有效')
        if (onSaved) onSaved(res)
        if (onClose) onClose()
      })
      .catch(() => {})
      .finally(() => this.setState({ applying: false }))
  }

  render () {
    const { project } = this.props
    const { scope, databasePermissionType, applying } = this.state
    const availability = getPermissionScopeAvailability(project)
    const allPermissionsHeld = hasAllPermissions(project)
    return <Modal
      title={`申请项目权限：${(project && project.projectName) || '-'}`}
      visible={this.props.visible}
      okText="确认申请"
      cancelText="取消"
      confirmLoading={applying}
      okButtonProps={{ disabled: allPermissionsHeld }}
      onOk={this.submit}
      onCancel={this.close}
      closable={!applying}
      maskClosable={!applying}
      destroyOnClose
    >
      {allPermissionsHeld
        ? <Alert
          type="success"
          showIcon
          message="已有全部权限"
          description="你已拥有本项目当前可申请的全部权限，无需重复申请。"
        />
        : <React.Fragment>
          <div style={{ marginBottom: 18 }}>
            <div style={{ marginBottom: 8 }}>授权范围</div>
            <Radio.Group
              value={scope}
              onChange={event => this.setState({ scope: event.target.value })}
            >
              <Space direction="vertical">
                <Radio value="database" disabled={!availability.database}>数据库权限</Radio>
                <Radio value="api" disabled={!availability.api}>接口权限</Radio>
                <Radio value="code" disabled={!availability.code}>
                  <div>代码仓库权限</div>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    可修改本项目代码、CI/CD 变量并发版部署（Maintainer）
                  </Text>
                </Radio>
                <Radio value="all" disabled={!availability.all}>
                  <div>全部权限</div>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    数据库 + 接口 + 代码仓库
                  </Text>
                </Radio>
              </Space>
            </Radio.Group>
          </div>
          {scope === 'database' || scope === 'all' ? (
            <div>
              <div style={{ marginBottom: 8 }}>数据库权限类型</div>
              <Radio.Group
                value={databasePermissionType}
                onChange={event => this.setState({ databasePermissionType: event.target.value })}
              >
                <Radio value="readonly">只读</Radio>
                <Radio value="readwrite">读写</Radio>
              </Radio.Group>
            </div>
          ) : null}
        </React.Fragment>}
    </Modal>
  }
}
